import type { Role } from "./types";

/**
 * Role matrix from the plan ("Akses per role").
 * Hiding a button is only a UI convenience — the backend (Supabase RLS) must enforce the same rules.
 */
export type Capability =
  | "schedule.edit" // input, edit topic, reschedule, swap, mark done, replacement, cancel
  | "summary.edit"
  | "rotation.manage" // generate, lock, unlock, fill from rotation
  | "admin.access"
  | "activity.view"
  | "mySchedule.view"
  | "insights.full"
  | "dashboard.myTurn";

const MATRIX: Record<Role, Capability[]> = {
  member: ["schedule.edit", "summary.edit", "activity.view", "mySchedule.view", "insights.full", "dashboard.myTurn"],
  system_manager: [
    "schedule.edit",
    "summary.edit",
    "rotation.manage",
    "admin.access",
    "activity.view",
    "mySchedule.view",
    "insights.full",
    "dashboard.myTurn",
  ],
  guest: [],
};

export function can(role: Role | undefined | null, capability: Capability): boolean {
  if (!role) return false;
  return MATRIX[role].includes(capability);
}
